import { render } from "./UserConsulenze.vue?vue&type=template&id=230906e0&scoped=true"
import script from "./UserConsulenze.vue?vue&type=script&lang=js"
export * from "./UserConsulenze.vue?vue&type=script&lang=js"

import "./UserConsulenze.vue?vue&type=style&index=0&id=230906e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230906e0"]])

export default __exports__